import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useReadLocalStorage } from 'usehooks-ts';

import { home } from 'router/routes';
import { LOCAL_STORAGE_KEY, STRING_STORAGE_VALUE_OPTIONS } from 'constants/localStorage';

const UnauthorizedOnlyRoute = () => {
  const location = useLocation();
  const authToken = useReadLocalStorage(LOCAL_STORAGE_KEY.AUTH_TOKEN, STRING_STORAGE_VALUE_OPTIONS);

  if (authToken) {
    return <Navigate replace to={home} state={{ from: location }} />;
  }

  return <Outlet />;
};

export default UnauthorizedOnlyRoute;
